import { X, ExternalLink, ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect } from "react";

export default function Lightbox({ items, index, onClose, onNav }) {
  const item = items[index];

  useEffect(() => {
    const h = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose, onNav]);

  if (!item) return null;

  return (
    <div
      data-testid="lightbox"
      className="fixed inset-0 z-[100] bg-ink/95 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button data-testid="lightbox-close" className="absolute top-4 right-4 text-parchment/80 hover:text-parchment" onClick={onClose}>
        <X className="h-7 w-7" />
      </button>
      <button
        className="absolute left-4 top-1/2 -translate-y-1/2 text-parchment/70 hover:text-parchment"
        onClick={(e) => { e.stopPropagation(); onNav(-1); }}
      >
        <ChevronLeft className="h-9 w-9" />
      </button>
      <button
        className="absolute right-4 top-1/2 -translate-y-1/2 text-parchment/70 hover:text-parchment"
        onClick={(e) => { e.stopPropagation(); onNav(1); }}
      >
        <ChevronRight className="h-9 w-9" />
      </button>

      <div className="max-w-5xl w-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
        <img src={item.image_url} alt={item.title} className="max-h-[75vh] w-auto object-contain rounded-lg shadow-2xl" />
        <div className="mt-4 text-center text-parchment max-w-2xl">
          <h3 className="font-serif text-xl">{item.title || "Untitled"}</h3>
          {item.caption && <p className="text-parchment/70 text-sm mt-1">{item.caption}</p>}
          <div className="text-parchment/50 text-xs mt-2 flex items-center justify-center gap-3 flex-wrap">
            {item.date && <span>{item.date}</span>}
            {item.source_collection && <span>· {item.source_collection}</span>}
            {item.link && (
              <a href={item.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-gold hover:underline">
                Source <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
